/** Lokalizace */

/** Uložit */
export const LOC_SAVE = "GUI-6";
/** Zavřít */
export const LOC_CLOSE = "GUI-4447";

/** Vlastnosti */
export const LOC_PROPERTIES = "WFL-716071";
/** Akce */
export const LOC_ACTIONS = "WFL-716072";
/** Hráči */
export const LOC_PARTICIPANTS = "WFL-716077";
/** Spouštěče */
export const LOC_TRIGGERS = "WFL-716075";
/** Propojení z/do */
export const LOC_TRANSITION_FROM_TO = "WFL-731668";
/** Příslušnost k sadám */
export const LOC_PERTINENCE_TO_SETS = "WFL-716078";
/** ID */
export const LOC_ID = "WFL-716130";
/** Název */
export const LOC_NAME = "WFL-716132";
/** Pořadí */
export const LOC_ORDER = "WFL-716133";
/** Podmínka */
export const LOC_CONDITION = "WFL-716134";
/** Typ větvení */
export const LOC_OPERATOR = "WFL-716136";
/** Popis */
export const LOC_DESCRIPTION = "WFL-716135";
/** Historie WF */
export const LOC_WF_HISTORY = "WFL-716153";
/** Dědit hráče */
export const LOC_INHERIT_PARTICIPANTS = "WFL-716154";
/** Spravovat */
export const LOC_MANAGE = "WFL-716613";
/** Typ větvení */
export const LOC_INPUT_TRANS_TYPE = "WFL-716606";
/** Zavření paralelních aktivit */
export const LOC_KILL_CHILDREN = "WFL-716607";
/** Název aktivity */
export const LOC_ACTIVITY_NAME = "WFL-717597";
/** Zobrazit v historii WF */
export const LOC_SHOW_IN_WF_HISTORY = "WFL-717598";
/** Dědí hráče z předešlé aktivity */
export const LOC_INHERIT_PARTICIPANTS_FROM_PREVIOUS_ACTIVITY = "WFL-717599";
/** Základní podmínka */
export const LOC_BASIC_CONDITION = "WFL-717606";
/** On-line vyhodnocená podmínka (pro podmínky typu ObjectExists nebo $username=,..) */
export const LOC_ONLINE_EVALUATED_CONDITION = "WFL-717607";
/** Typ pro spojení */
export const LOC_TYPE_FOR_JOIN = "WFL-717622";
/** Typ pro větvení */
export const LOC_TYPE_FOR_SPLIT = "WFL-717623";
/** Menu */
export const LOC_MENU = "WFL-717677";
/** Zpráva Workflow */
export const LOC_WORKFLOW_MESSAGE = "WFL-717679";
/** Vznik dokladu */
export const LOC_CREATION_OF_DOCUMENT = "WFL-717681";
/** Změna hodnoty atributu */
export const LOC_ATTRIBUTE_VALUE_CHANGE = "WFL-717682";
/** Změna atributu */
export const LOC_ATTRIBUTE_CHANGE = "WFL-717696";
/** Změna vazebního atributu */
export const LOC_CHANGE_OF_BINDING_ATTRIBUTE = "WFL-717697";
/** Inkrementace hodnoty */
export const LOC_INCREMENTING_VALUE = "WFL-717698";
/** Nastavení hodnoty */
export const LOC_SETTING_VALUE = "WFL-717699";
/** Provedení metody */
export const LOC_EXECUTING_METHOD = "WFL-717701";
/** Odeslání WF zprávy */
export const LOC_SENDING_OF_WF_MESSAGE = "WFL-717702";
/** E-mail */
export const LOC_EMAIL = "WFL-717704";
/** SMS */
export const LOC_SMS = "WFL-717705";
/** Spuštění skriptu */
export const LOC_START_OF_SCRIPT = "WFL-717706";
/** Otevření formuláře */
export const LOC_FORM_OPENING = "WFL-717707";
/** Uživatel */
export const LOC_USER = "WFL-717801";
/** Vlastník */
export const LOC_OWNER = "WFL-717802";
/** Systém */
export const LOC_SYSTEM = "WFL-717804";
/** Role */
export const LOC_ROLE = "WFL-717803";
/** Definiční hráč */
export const LOC_DEFINITION_PARTICIPANT = "WFL-717805";
/** Přiblížit */
export const LOC_ZOOM_IN = "WFL-717840";
/** Oddálit */
export const LOC_ZOOM_OUT = "WFL-717841";
/** Název propojení */
export const LOC_TRANSITION_NAME = "WFL-717926";
/** Spoušťěná funkce */
export const LOC_CALLED_FUNCTION = "WFL-718278";
/** Statická */
export const LOC_STATIC = "WFL-718279";
/** Textový parametr */
export const LOC_TEXT_PARAMETER = "WFL-718280";
/** Použít objekt parametrického formuláře */
export const LOC_USE_PARAMETRIC_FORM_OBJECT = "WFL-718281";
/** Použít aktuální objekt */
export const LOC_USE_CURRENT_OBJECT = "WFL-718284";
/** Komentář */
export const LOC_COMMENT = "WFL-718285";
/** Nová hodnota */
export const LOC_NEW_VALUE = "WFL-718292";
/** Měněný atribut */
export const LOC_CHANGED_ATTRIBUTE = "WFL-718299";
/** Atribut hodnoty */
export const LOC_VALUE_ATTRIBUTE = "WFL-718300";
/** Nadřízená třída */
export const LOC_SUPERIOR_CLASS = "WFL-718301";
/** Nový WF Stav */
export const LOC_NEW_WF_STATE = "WFL-718302";
/** Hodnota */
export const LOC_VALUE = "WFL-718303";
/** Krok změny */
export const LOC_STEP_CHANGE = "WFL-718305";
/** Typ inkrementace */
export const LOC_INCREMENT_TYPE = "WFL-718307";
/** Měněný údaj */
export const LOC_CHANGED_DATA = "WFL-718310";
/** Odesílaná zpráva WfMsg */
export const LOC_OUTGOING_MESSAGE_WF = "WFL-718311";
/** Podmínka pro WfMsg */
export const LOC_CONDITION_FOR_WF_MESSAGE = "WFL-718312";
/** Třída objektů */
export const LOC_CLASS_OBJECTS = "WFL-718313";
/** Podmínka pro objekty */
export const LOC_CONDITION_FOR_OBJECTS = "WFL-718314";
/** Parametry podmínky */
export const LOC_CONDITION_PARAMETERS = "WFL-718315";
/** Zpracovat pro uložení objektu */
export const LOC_PROCESS_TO_SAVE_OBJECT = "WFL-718316";
/** Skript */
export const LOC_SCRIPT = "WFL-718317";
/** Text */
export const LOC_TEXT = "WFL-718394";
/** Typ adresy */
export const LOC_ADDRESS_TYPE = "WFL-718397";
/** Adresát */
export const LOC_ADDRESSEE = "WFL-718398";
/** Předmět zprávy */
export const LOC_MESSAGE_SUBJECT = "WFL-718401";
/** Formát zprávy */
export const LOC_MESSAGE_FORMAT = "WFL-718402";
/** Sumární email */
export const LOC_SUMMARY_EMAIL = "WFL-718406";
/** Odložené odeslání */
export const LOC_DELAYED_SENDING = "WFL-718407";
/** Šablona sestavy */
export const LOC_REPORT_TEMPLATE = "WFL-718419";
/** Třída dokumentů */
export const LOC_DOCUMENT_CLASS = "WFL-718420";
/** Atribut */
export const LOC_ATTRIBUTE = "WFL-718421";
/** Podmínka výběru dokumentů */
export const LOC_CONDTION_SELECTION_DOCUMENTS = "WFL-718422";
/** Typ akce */
export const LOC_ACTION_TYPE = "WFL-718454";
/** Atribut události */
export const LOC_EVENT_ATTRIBUTE = "WFL-718624";
/** Očekáváná hodnota atributu */
export const LOC_EXPECTED_ATTRIBUTE_VALUE = "WFL-718625";
/** Název zprávy WFMsg */
export const LOC_WFMSG_MESSAGE_NAME = "WFL-718630";
/** Zavířá aktivitu */
export const LOC_CLOSES_ACTIVITY = "WFL-718631";
/** Typ spouštěče */
export const LOC_TRIGGER_TYPE = "WFL-718632";
/** Ikona */
export const LOC_ICON = "WFL-811544";
/** Zobrazení */
export const LOC_DISPLAY = "WFL-812418";
/** Ostatní */
export const LOC_OTHER = "WFL-812419";
/** Přidat sadu */
export const LOC_ADD_SET = "WFL-719063";
/** Průběžná aktivita */
export const LOC_ONGOING_ACTIVITY = "WFL-719104";
/** Poznámka */
export const LOC_NOTE = "WFL-719105";
/** Vybírat z hráčů */
export const LOC_CHOOSE_FROM_PARTICIPANTS = "WFL-719178";
/** Provést validaci odloženě povinných polí */
export const LOC_VALIDATE_DEFERRED_REQUIRED_FIELDS = "WFL-719179";
/** Vhodné pro hromadné spuštění */
export const LOC_SUITABLE_FOR_MASS_LAUNCH = "WFL-719180";
/** Provést validaci doporučených polí */
export const LOC_VALIDATE_THE_RECOMMENDED_FIELDS = "WFL-719181";
/** Nadřízená položka menu (uzel) */
export const LOC_PARENT_MENU_ITEM = "WFL-719182";
/** Vybírat konkrétní uživatele */
export const LOC_CHOOSE_FROM_USERS_DEFAULT = "WFL-779990";
/** Parametrický formulář */
export const LOC_PARAMETRIC_FORM = "WFL-719183";
/** Vazba na objekt */
export const LOC_OBJECT_BINDING = "WFL-719184";
/** Nastavení hodnot pro parametrický formulář */
export const LOC_SETTING_A_VALUE_FOR_THE_PARAMETRIC_FORM = "WFL-719185";
/** Ukázka: Nazev_Hodnoty1=hodnota1;Nazev_Hodnoty2=hodnota2;... */
export const LOC_EXAMPLE = "WFL-719186";
/** Editovat definiční hráče */
export const LOC_EDIT_DEFINITION_PARTICIPANTS = "WFL-720769";
/** Aktualizovat */
export const LOC_REFRESH = "WFL-720773";
/** Není potřeba žádných parametrů */
export const LOC_NO_PARAMETERS_NEEDED = "WFL-720847";
/** Přidat */
export const LOC_ADD = "WFL-721870";
/** Zrušit */
export const LOC_CANCEL = "WFL-721871";
/** Nejsou dostupné žádné existující aktivity... */
export const LOC_NO_EXISTING_ACTIVITIES_MESSAGE = "WFL-722585";
/** Duplikovat */
export const LOC_DUPLICATE = "WFL-737115";
/** Nejsou dostupné žádné sady... */
export const LOC_NO_SETS_MESSAGE = "WFL-737075";
/** Vyberte aktivity, které se přidají do sady */
export const LOC_CHOOSE_ACTIVITIES_TO_ADD = "WFL-737128";
/** Vyberte sadu, do které se má duplikovat */
export const LOC_CHOOSE_SET_TO_DUPLICATE_TO = "WFL-737123";
/** Žádná akce zatím nebyla vytvořena... */
export const LOC_NO_ACTION_CREATED = "WFL-722681";
/** Žádný spouštěč zatím nebyl vytvořen... */
export const LOC_NO_TRIGGER_CREATED = "WFL-722746";
/** Třída */
export const LOC_CLASS = "WFL-722993";
/** Název atributu */
export const LOC_ATTRIBUTE_NAME = "WFL-722994";
/** Podmínka pro data */
export const LOC_DATA_CONDITION = "WFL-722995";
/** Žádný definiční hráč zatím nebyl vytvořen... */
export const LOC_NO_DEFINITION_PARTICIPANT_CREATED = "WFL-723464";
/** Typ formuláře */
export const LOC_FORM_TYPE = "WFL-723841";
/** Formulář */
export const LOC_FORM = "WFL-723842";
/** Podmínka formuláře */
export const LOC_FORM_CONDITION = "WFL-723843";
/** Název sestavy */
export const LOC_REPORT_NAME = "WFL-723877";
/** Proměnné */
export const LOC_VARIABLES = "WFL-725240";
/** Sestava */
export const LOC_REPORT = "WFL-726585";
/** Parametrický formulář sestavy */
export const LOC_PRINT_FORM = "WFL-726588";
/** Parametrický formulář funkce */
export const LOC_ACTION_FORM = "WFL-726589";
/** Ano */
export const LOC_YES = "WFL-725468";
/** Ne */
export const LOC_NO = "WFL-725469";
/** Opravdu chcete smazat vybranou akci? */
export const LOC_DELETE_SELECTED_ACTION = "WFL-725725";
/** Opravdu chcete smazat vybraný spouštěč? */
export const LOC_DELETE_SELECTED_TRIGGER = "WFL-725726";
/** Opravdu chcete smazat vybraného hráče? */
export const LOC_DELETE_SELECTED_PARTICIPANT = "WFL-725727";
/** Opravdu chcete smazat vybrané prvky? */
export const LOC_DELETE_SELECTED_ELEMENTS = "WFL-731542";
/** Opravdu chcete přenačíst instanci workflow? Přijdete o všechny neuložené změny. */
export const LOC_RELOAD_WORKFLOW_DIALOG = "WFL-725734";
/** Opravdu chcete smazat sadu? */
export const LOC_DELETE_SET = "WFL-725739";
/** Smazat */
export const LOC_DELETE = "WFL-726642";
/** OK */
export const LOC_OK = "WFL-727061";
/** Obnovit */
export const LOC_RESTORE = "WFL-727084";
/** Prozkoumat */
export const LOC_EXPLORE = "WFL-728036";
/** Legenda */
export const LOC_LEGEND = "WFL-728264";
/** On-line vyhodnocená podmínka */
export const LOC_ONLINE_EVAL_CONDITION = "WFL-728364";
/** Značí, jestli se aktivita objevuje i v jiných sadách. */
export const LOC_LEGEND_PERTIENCE_DESCRIPTION = "WFL-728366";
/** Volba pro zajištění jediné cesty pro pokračování WF (více v PA řešení WF). */
export const LOC_LEGEND_KILL_CHILDREN_DESCRIPTION = "WFL-728367";
/** Needitačně. Pokud není definován spouštěč, pak je to automaticky průběžná aktivita. */
export const LOC_LEGEND_ONGOING_DESCRIPTION = "WFL-728377";
/** Přebírání aktivních hráčů z předcházejících aktivit (použití v adresném přidělení, zapamatování hráčů apod., více v PA řešení WF). */
export const LOC_LEGEND_INHERIT_PARTICIPANTS_DESCRIPTION = "WFL-728378";
/** Možnost volby XOR nebo AND (více v PA řešení WF). */
export const LOC_LEGEND_TYPE_FOR_JOIN_DESCRIPTION = "WFL-728381";
/** Indikuje, zda aktivita obsahuje on-line vyhodnocenou podmínku. */
export const LOC_LEGEND_ONLINE_EVAL_CONDITION_DESCRIPTION = "WFL-728387";
/** Indikuje, zda propojení obsahuje základní podmínku. */
export const LOC_LEGEND_BASIC_CONDITION_DESCRIPTION = "WFL-728394";
/** Aktivní hráči */
export const LOC_ACTIVE_PARTICIPANTS = "WFL-729344";
/** Obsahuje akce */
export const LOC_CONTAINS_ACTIONS = "WFL-729371";
/** Indikuje, zda propojení obsahuje akce. */
export const LOC_LEGEND_CONTAINS_ACTIONS_DESCRIPTION = "WFL-729368";
/** Indikuje, zda aktivita obsahuje základní podmínku. */
export const LOC_LEGEND_CONTAINS_BASIC_CONDITION_DESCRIPTION = "WFL-729372";
/** Nový hráč */
export const LOC_NEW_PARTICIPANT = "WFL-729612";
/** Text v menu */
export const LOC_MENU_TEXT = "WFL-730678";
/** Potvrzovací hláška */
export const LOC_CONFIRMATION_MESSAGE = "WFL-730679";
/** Jazyk */
export const LOC_LANGUAGE = "WFL-730680";
/** Zahodit */
export const LOC_DISCARD = "WFL-730602";
/** Načíst (přenačíst) */
export const LOC_RELOAD = "WFL-730800";
/** Vede do aktivity */
export const LOC_LEADS_TO_ACTIVITY = "WFL-731751";
/** Vede z aktivity */
export const LOC_LEADS_FROM_ACTIVITY = "WFL-731752";
/** Propojení vedoucí do aktivity */
export const LOC_TRANSITIONS_LEADING_TO_ACTIVITY = "WFL-731812";
/** Propojení vedoucí z aktivity */
export const LOC_TRANSITIONS_LEADING_FROM_ACTIVITY = "WFL-731813";
/** Neexistuje žádné propojení vedoucí do aktivity... */
export const LOC_TRANSITION_TO_ACTIVITY_NOT_EXISTS = "WFL-731814";
/** Neexistuje žádné propojení vedoucí z aktivity... */
export const LOC_TRANSITION_FROM_ACTIVITY_NOT_EXISTS = "WFL-731815";
/** Kód (vlastnost spouštěče menu) */
export const LOC_CODE_NAME = "WFL-731889";
/** Nelze smazat zobrazenou sadu! */
export const LOC_CANNOT_DELETE_DISPLAYED_SET = "WFL-736158";
/** Opravdu chcete smazat zvolenou sadu? */
export const LOC_REALLY_DELETE_SET = "WFL-736165";
/** Nová sada */
export const LOC_NEW_SET = "WFL-736651";
/** Vyhledat aktivitu... */
export const LOC_SEARCH_ACTIVITY = "WFL-736986";
/** Propojit */
export const LOC_CONNECT = "WFL-738501";
/** Aktivita '{0}': Povinný atribut '{1}' nebyl vyplněn! Nelze vytvořit akci '{2}'. */
export const LOC_ACTION_VALIDATION_ERROR = "WFL-737173";
/** Aktivita '{0}': Povinný atribut '{1}' nebyl vyplněn! Nelze vytvořit spouštěč '{2}'. */
export const LOC_TRIGGER_VALIDATION_ERROR = "WFL-737174";
/** Vyhledat... */
export const LOC_SEARCH = "WFL-740282";
/** Startovací */
export const LOC_STARTING = "WFL-740402";
/** Existující do sady */
export const LOC_EXISTING_INTO_THE_SET = "WFL-740403";
/** Běžná */
export const LOC_COMMON = "WFL-740404";
/** Konečná */
export const LOC_FINAL = "WFL-740405";
/** Upravit */
export const LOC_EDIT = "WFL-738500";
/** Tisk */
export const LOC_PRINT = "WFL-740412";
/** SADA */
export const LOC_SET = "WFL-740413";
/** Nastavení sady */
export const LOC_SET_SETTINGS = "WFL-740414";
/** Aktualizuje obsah */
export const LOC_UPDATES_THE_CONTENT = "WFL-740417";
/** Přepnout mřížku */
export const LOC_TOGGLE_GRID = "WFL-740422";
/** Resetovat */
export const LOC_RESET = "WFL-740423";
/** Odebrat */
export const LOC_REMOVE = "WFL-740424";
/** Kopírovat */
export const LOC_COPY = "WFL-740425";
/** Posunout nahoru */
export const LOC_MOVE_UP = "WFL-740426";
/** Posunout dolů */
export const LOC_MOVE_DOWN = "WFL-740427";
/** Zadána přímo */
export const LOC_ENTERED_DIRECTLY = "WFL-740529";
/** Hodnota atributu */
export const LOC_ATTRIBUTE_VALUE = "WFL-740537";
/** Aktuální uživatel */
export const LOC_CURRENT_USER = "WFL-740540";
/** Aktuální hráči */
export const LOC_CURRENT_PARTICIPANTS = "WFL-740541";
/** Následující hráči */
export const LOC_FOLLOWING_PARTICIPANTS = "WFL-740542";
/** Okruh kompetence */
export const LOC_AREA_OF_COMPETENCE = "WFL-740543";
/** Z jiných záznamů */
export const LOC_FROM_OTHER_RECORDS = "WFL-740544";
/** Zpráva */
export const LOC_MESSAGE = "WFL-740545";
/** Přílohy */
export const LOC_ATTACHMENTS = "WFL-740546";
/** Číslo */
export const LOC_NUMBER = "WFL-740810";
/** Vteřina */
export const LOC_SECOND = "WFL-740812";
/** Minuta */
export const LOC_MINUTE = "WFL-740817";
/** Hodina */
export const LOC_HOUR = "WFL-740818";
/** Den */
export const LOC_DAY = "WFL-740819";
/** Týden */
export const LOC_WEEK = "WFL-740820";
/** Měsíc */
export const LOC_MONTH = "WFL-740821";
/** Rok */
export const LOC_YEAR = "WFL-740828";
/** Smazat (Delete) */
export const LOC_DELETE_KEY_DELETE = "WFL-744133";
/** Propojit (Mezerník) */
export const LOC_CONNECT_KEY_SPACEBAR = "WFL-744134";
/** Opravdu chcete zahodit všechny provedené změny? */
export const LOC_DISCARD_CHANGES = "WFL-744298";
/** K použitému filtru se nepodařilo najít žádný záznam. */
export const LOC_NO_ITEMS_FOUND = "WFL-793079";

export const LOC_KEYS_WF_EDITOR: readonly string[] = [
    LOC_SAVE,
    LOC_CLOSE,
    LOC_PROPERTIES,
    LOC_ACTIONS,
    LOC_PARTICIPANTS,
    LOC_TRIGGERS,
    LOC_PERTINENCE_TO_SETS,
    LOC_ID,
    LOC_NAME,
    LOC_ORDER,
    LOC_CONDITION,
    LOC_OPERATOR,
    LOC_DESCRIPTION,
    LOC_WF_HISTORY,
    LOC_INHERIT_PARTICIPANTS,
    LOC_MANAGE,
    LOC_INPUT_TRANS_TYPE,
    LOC_KILL_CHILDREN,
    LOC_ACTIVITY_NAME,
    LOC_SHOW_IN_WF_HISTORY,
    LOC_INHERIT_PARTICIPANTS_FROM_PREVIOUS_ACTIVITY,
    LOC_BASIC_CONDITION,
    LOC_ONLINE_EVALUATED_CONDITION,
    LOC_TYPE_FOR_JOIN,
    LOC_TYPE_FOR_SPLIT,
    LOC_MENU,
    LOC_WORKFLOW_MESSAGE,
    LOC_CREATION_OF_DOCUMENT,
    LOC_ATTRIBUTE_VALUE_CHANGE,
    LOC_ATTRIBUTE_CHANGE,
    LOC_CHANGE_OF_BINDING_ATTRIBUTE,
    LOC_INCREMENTING_VALUE,
    LOC_SETTING_VALUE,
    LOC_EXECUTING_METHOD,
    LOC_SENDING_OF_WF_MESSAGE,
    LOC_EMAIL,
    LOC_SMS,
    LOC_START_OF_SCRIPT,
    LOC_FORM_OPENING,
    LOC_USER,
    LOC_OWNER,
    LOC_SYSTEM,
    LOC_ROLE,
    LOC_DEFINITION_PARTICIPANT,
    LOC_ZOOM_IN,
    LOC_ZOOM_OUT,
    LOC_TRANSITION_NAME,
    LOC_CALLED_FUNCTION,
    LOC_STATIC,
    LOC_TEXT_PARAMETER,
    LOC_USE_PARAMETRIC_FORM_OBJECT,
    LOC_USE_CURRENT_OBJECT,
    LOC_COMMENT,
    LOC_NEW_VALUE,
    LOC_CHANGED_ATTRIBUTE,
    LOC_VALUE_ATTRIBUTE,
    LOC_SUPERIOR_CLASS,
    LOC_NEW_WF_STATE,
    LOC_VALUE,
    LOC_STEP_CHANGE,
    LOC_INCREMENT_TYPE,
    LOC_CHANGED_DATA,
    LOC_OUTGOING_MESSAGE_WF,
    LOC_CONDITION_FOR_WF_MESSAGE,
    LOC_CLASS_OBJECTS,
    LOC_CONDITION_FOR_OBJECTS,
    LOC_CONDITION_PARAMETERS,
    LOC_PROCESS_TO_SAVE_OBJECT,
    LOC_SCRIPT,
    LOC_TEXT,
    LOC_ADDRESS_TYPE,
    LOC_ADDRESSEE,
    LOC_MESSAGE_SUBJECT,
    LOC_MESSAGE_FORMAT,
    LOC_SUMMARY_EMAIL,
    LOC_DELAYED_SENDING,
    LOC_REPORT_TEMPLATE,
    LOC_DOCUMENT_CLASS,
    LOC_ATTRIBUTE,
    LOC_CONDTION_SELECTION_DOCUMENTS,
    LOC_ACTION_TYPE,
    LOC_EVENT_ATTRIBUTE,
    LOC_EXPECTED_ATTRIBUTE_VALUE,
    LOC_WFMSG_MESSAGE_NAME,
    LOC_CLOSES_ACTIVITY,
    LOC_TRIGGER_TYPE,
    LOC_ICON,
    LOC_DISPLAY,
    LOC_OTHER,
    LOC_ADD_SET,
    LOC_ONGOING_ACTIVITY,
    LOC_NOTE,
    LOC_CHOOSE_FROM_PARTICIPANTS,
    LOC_VALIDATE_DEFERRED_REQUIRED_FIELDS,
    LOC_SUITABLE_FOR_MASS_LAUNCH,
    LOC_VALIDATE_THE_RECOMMENDED_FIELDS,
    LOC_PARENT_MENU_ITEM,
    LOC_PARAMETRIC_FORM,
    LOC_OBJECT_BINDING,
    LOC_SETTING_A_VALUE_FOR_THE_PARAMETRIC_FORM,
    LOC_EXAMPLE,
    LOC_EDIT_DEFINITION_PARTICIPANTS,
    LOC_REFRESH,
    LOC_NO_PARAMETERS_NEEDED,
    LOC_ADD,
    LOC_CANCEL,
    LOC_NO_EXISTING_ACTIVITIES_MESSAGE,
    LOC_NO_ACTION_CREATED,
    LOC_NO_TRIGGER_CREATED,
    LOC_CLASS,
    LOC_ATTRIBUTE_NAME,
    LOC_DATA_CONDITION,
    LOC_NO_DEFINITION_PARTICIPANT_CREATED,
    LOC_FORM_TYPE,
    LOC_FORM,
    LOC_FORM_CONDITION,
    LOC_REPORT_NAME,
    LOC_VARIABLES,
    LOC_REPORT,
    LOC_PRINT_FORM,
    LOC_ACTION_FORM,
    LOC_YES,
    LOC_NO,
    LOC_DELETE_SELECTED_ACTION,
    LOC_DELETE_SELECTED_TRIGGER,
    LOC_DELETE_SELECTED_PARTICIPANT,
    LOC_RELOAD_WORKFLOW_DIALOG,
    LOC_DELETE_SET,
    LOC_DELETE,
    LOC_OK,
    LOC_RESTORE,
    LOC_EXPLORE,
    LOC_LEGEND,
    LOC_ONLINE_EVAL_CONDITION,
    LOC_LEGEND_PERTIENCE_DESCRIPTION,
    LOC_LEGEND_KILL_CHILDREN_DESCRIPTION,
    LOC_LEGEND_ONGOING_DESCRIPTION,
    LOC_LEGEND_INHERIT_PARTICIPANTS_DESCRIPTION,
    LOC_LEGEND_TYPE_FOR_JOIN_DESCRIPTION,
    LOC_LEGEND_ONLINE_EVAL_CONDITION_DESCRIPTION,
    LOC_LEGEND_BASIC_CONDITION_DESCRIPTION,
    LOC_ACTIVE_PARTICIPANTS,
    LOC_CONTAINS_ACTIONS,
    LOC_LEGEND_CONTAINS_ACTIONS_DESCRIPTION,
    LOC_LEGEND_CONTAINS_BASIC_CONDITION_DESCRIPTION,
    LOC_NEW_PARTICIPANT,
    LOC_MENU,
    LOC_CONFIRMATION_MESSAGE,
    LOC_LANGUAGE,
    LOC_DISCARD,
    LOC_RELOAD,
    LOC_TRANSITION_FROM_TO,
    LOC_LEADS_FROM_ACTIVITY,
    LOC_LEADS_TO_ACTIVITY,
    LOC_TRANSITIONS_LEADING_TO_ACTIVITY,
    LOC_TRANSITIONS_LEADING_FROM_ACTIVITY,
    LOC_TRANSITION_TO_ACTIVITY_NOT_EXISTS,
    LOC_TRANSITION_FROM_ACTIVITY_NOT_EXISTS,
    LOC_DELETE_SELECTED_ELEMENTS,
    LOC_CODE_NAME,
    LOC_CANNOT_DELETE_DISPLAYED_SET,
    LOC_REALLY_DELETE_SET,
    LOC_NEW_SET,
    LOC_NO_SETS_MESSAGE,
    LOC_DUPLICATE,
    LOC_CHOOSE_SET_TO_DUPLICATE_TO,
    LOC_CHOOSE_ACTIVITIES_TO_ADD,
    LOC_SEARCH_ACTIVITY,
    LOC_EDIT,
    LOC_CONNECT,
    LOC_ACTION_VALIDATION_ERROR,
    LOC_TRIGGER_VALIDATION_ERROR,
    LOC_SEARCH,
    LOC_STARTING,
    LOC_EXISTING_INTO_THE_SET,
    LOC_COMMON,
    LOC_FINAL,
    LOC_SET,
    LOC_SET_SETTINGS,
    LOC_PRINT,
    LOC_UPDATES_THE_CONTENT,
    LOC_TOGGLE_GRID,
    LOC_RESET,
    LOC_MENU_TEXT,
    LOC_REMOVE,
    LOC_COPY,
    LOC_MOVE_UP,
    LOC_MOVE_DOWN,
    LOC_ENTERED_DIRECTLY,
    LOC_ATTRIBUTE_VALUE,
    LOC_CURRENT_USER,
    LOC_CURRENT_PARTICIPANTS,
    LOC_FOLLOWING_PARTICIPANTS,
    LOC_AREA_OF_COMPETENCE,
    LOC_FROM_OTHER_RECORDS,
    LOC_MESSAGE,
    LOC_ATTACHMENTS,
    LOC_NUMBER,
    LOC_SECOND,
    LOC_MINUTE,
    LOC_HOUR,
    LOC_DAY,
    LOC_WEEK,
    LOC_MONTH,
    LOC_YEAR,
    LOC_DELETE_KEY_DELETE,
    LOC_CONNECT_KEY_SPACEBAR,
    LOC_DISCARD_CHANGES,
    LOC_CHOOSE_FROM_USERS_DEFAULT,
    LOC_NO_ITEMS_FOUND,
];
